import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "./authCrud";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
  SetRedirectUrl: "[Set Redirect Url] Action"
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  redirectTo: undefined,
  isAdmin: false,
  isPowerUser: false
};

export const reducer = persistReducer(
  { storage, key: "v713-demo1-auth", whitelist: ["user", "authToken", "redirectTo"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;

        return { ...state, authToken, user: undefined };
      }
      case actionTypes.SetRedirectUrl: {
        const { redirectTo } = action.payload;

        return { ...state, redirectTo };
      }
      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { ...state, authToken, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;
        const isAdmin = ['prismadmin@fieldgenie.com','chandra.pandit@prismjohnson.in', 'raghavendra.pathak@prismjohnson.in', 'kamlesh.soni@prismjohnson.in', 'premnath.pandey@prismjohnson.in']
          .includes(user?.email || '') ? true : false;
        const isPowerUser = ['mines.cr@prismjohnson.in', 'pspariharpc@gmail.com', 'satendrapratapsinghchauhan385@gmail.com', 'vinodshrivasrtva1975@gmail.com' ]
        .includes(user?.email || '') ? true : false;
        console.log("user.email", user?.email, "isAdmin", isAdmin, "isPowerUser", isPowerUser);
        return { ...state, user, isAdmin, isPowerUser };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
  SetRedirectUrl: (redirectTo) => ({type: actionTypes.SetRedirectUrl, payload: {redirectTo}})
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const { data: user } = yield getUserByToken();

    yield put(actions.fulfillUser(user));
  });
}
